import type { BottomNavigationAction, BottomNavigationDrawerAction } from "@bonusx-global/bx-design-system";
import { isDrawerTogglerPath } from "../is-drawer-toggler-path/is-drawer-toggler-path";
import type { IEnrichRouteWithSelectedStatus } from "./enrich-route-with-selected-status.interface";

export function enrichRouteWithSelectedStatus({
  route,
  currentPathName,
  isDrawerRouteSelected,
}: IEnrichRouteWithSelectedStatus): BottomNavigationDrawerAction | BottomNavigationAction {
  const updatedRoute = { ...route };

  if (isDrawerTogglerPath(updatedRoute.path)) {
    updatedRoute.selected = isDrawerRouteSelected;
    return updatedRoute;
  }

  if (isDrawerRouteSelected) {
    updatedRoute.selected = false;
    return updatedRoute;
  }

  updatedRoute.selected = updatedRoute.path === currentPathName;

  return updatedRoute;
}
